import React from 'react'
import styled from 'styled-components'
import { string } from 'prop-types'
import { ReactComponent as GooglePlay } from '../../assets/svg/google-play.svg'
import { ReactComponent as AppStore } from '../../assets/svg/apple-app-store.svg'
import { ReactComponent as Instargram } from '../../assets/svg/instargram.svg'
import { GOOGLE_PLAY_URL, APPLE_STORE_URL, INSTARGRAM_URL } from '../../lib/constant'

export default function Stores({ className }) {
	return (
		<Block className={className}>
			<StoreLink href={GOOGLE_PLAY_URL} className="google-play">
				<GooglePlay />
			</StoreLink>
			<StoreLink href={APPLE_STORE_URL} className="apple-store">
				<AppStore />
			</StoreLink>
			<StoreLink href={INSTARGRAM_URL} className="instargram">
				<Instargram />
			</StoreLink>
		</Block>
	)
}

Stores.propTypes = {
	className: string,
}

Stores.defaultProps = {
	className: '',
}

const Block = styled.div`
	display: flex;

	> a {
		cursor: pointer;
	}

	> .apple-store {
		margin-left: 8px;
	}
	> .instargram {
		margin-left: 8px;
	}
`

const Anchor = styled.a.attrs({
	rel: 'noreferrer noopener',
	target: '_blank',
})``

const StoreLink = styled(Anchor)`
	height: 40px;
	&:hover {
		opacity: 0.7;
	}
`
